import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=ef62a514&scoped=true"
var script = {}
import style0 from "./Default.vue?vue&type=style&index=0&id=ef62a514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_@vue+compiler-sfc@3.5.17_b_3cd151110130808e214f6f819bd7543a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef62a514",
  null
  
)

export default component.exports